import { render } from "./LabelCheckboxField.vue?vue&type=template&id=6587882b"
import script from "./LabelCheckboxField.vue?vue&type=script&lang=js"
export * from "./LabelCheckboxField.vue?vue&type=script&lang=js"

import "../styles/LabelCheckboxField.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__